// 首页
<template>
  <div class="home_wrap">
    <!-- 内容 -->
    <div class="home_cont">
      <!-- 带图片的内容模块 -->
      <div class="cont_img">
        <el-carousel
          class="new_wrap curPointer"
          height="560px"
          indicator-position="outside" v-if="imgNews!=false"
        >
          <el-carousel-item v-for="(item, index) in imgNews" :key="index" @click="detailClick(item.articleId,item.categoryId,item.categoryName)">
            <el-image class="new_img" :src="item.coverImage?item.coverImage:swiperBanner" fit="cover"></el-image>
            <h3 class="new_title" justify="center">{{ item.title }}</h3>
          </el-carousel-item>
        </el-carousel>
        <el-carousel
          class="new_wrap"
          height="560px"
          indicator-position="outside" v-else
        >
          <el-carousel-item>
            <el-image class="new_img" :src="swiperBanner" fit="cover"></el-image>
            <h3 class="new_title" justify="center">中察法制监督网</h3>
          </el-carousel-item>
        </el-carousel>
        
        <div
          class="report_cont"
         >
          <div class="cont_head">
            <p class="head_p">{{ constList24.categoryName }}</p>
            <span @click="listClick(2,constList24.categoryId,constList24.categoryName)" class="head_span curPointer"
              >更多 ＞</span
            >
          </div>
          <div>
            <div v-if="constList24.articleList != false">
              <div
                @click="detailClick(constList24.articleList[index].articleId,constList24.categoryId,constList24.categoryName)"
                class="cont_list"
                v-for="(item, index) in constList24.articleList"
                :key="index"
              >
                <a
                  class="newsList ellipsis"
                  :href="item.url"
                  >{{ item.title }}</a
                >
              </div>
            </div>
            <div v-else><p class="home_empty">暂无数据</p></div>
          </div>
        </div>
      </div>
      <!-- 专题报道 法律援助 -->
      <div class="cont_report">
        <div class="report_cont" style="width:650px;">
          <div class="cont_head">
            <p class="head_p">{{ constList33.categoryName }}</p>
            <span @click="listClick(2,constList33.categoryId,constList33.categoryName)" class="head_span curPointer"
              >更多 ＞</span
            >
          </div>
          <div v-if="constList33!=false&&constList33.articleList[0]!=false" class="left_imgCont" @click="detailClick(constList33.articleList[0].articleId,constList33.articleList[0].categoryId,constList33.categoryName)">
            <div class="img_left"><MoudleImg :imgSrc="constList33.articleList[0].coverImage!=false?constList33.articleList[0].coverImage:null"  :textCont="constList33.categoryName" :elementWidth="400" /></div>
            <div class="left_cont">
              <p class="cont_title ellipsis3">{{constList33.articleList[0].title}}</p>
              <p class="cont_des ellipsis7">{{constList33.articleList[0].description}}</p>
            </div>
          </div>
          <div class="left_ul" >
            <div  v-for="(item, index) in constList33.articleList" :key="index">
            <a class="newsList "  @click="detailClick(item.articleId,item.categoryId,constList33.categoryName)" v-if="index>0"><p class="left_img ellipsis">{{ item.title}}</p></a>
            </div>
          </div>
        </div>
        <div class="report_right">
          <div
            class="report_cont"
            v-for="(itemA, indexA) in constList32"
            :key="indexA"
          >
            <div class="cont_head">
              <p class="head_p">{{ constList32[indexA].categoryName }}</p>
              <span @click="listClick(2,constList32[indexA].categoryId,constList32[indexA].categoryName)" class="head_span curPointer"
                >更多 ＞</span
              >
            </div>
            <div>
              <div>
                <div
                  @click="detailClick(constList32[indexA].articleList[index].articleId,constList32[indexA].categoryId,constList32[indexA].categoryName)"
                  class="cont_list"
                  v-for="(item, index) in constList32[indexA].articleList"
                  :key="index"
                >
                <a class="list_img" v-if="index == 0">
                     <div class="img">
                      <MoudleImg :imgSrc="item.coverImage!=false?item.coverImage:null" :textCont="constList32[indexA].categoryName " />
                     </div>
                    <div class="img_right">
                      <p class="right_title ellipsis2">{{ item.title }}</p>
                      <p class="right_desic ellipsis3">{{ item.description }}</p>
                    </div>
                  </a>
                  <a
                    v-else-if="index < 6"
                    class="newsList ellipsis"
                    >{{ item.title }}</a
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 广告 -->
      <el-image class="middle_img"
                :src="imgadTop"
                fit="cover" @click="adClick('top')"
              ></el-image>
      <!-- 新反腐倡廉 -->
       <div class="cont_wrap" v-for="(ite,ind) in constList29" :key="ind">
       <div class="cont_ff" v-if="constList29!=false&&constList29!=null&&constList29[ind][0]!=null">
        <div class="ff_title"  @click="listClick(2,constList29[ind][0].categoryId,constList29[ind][0].categoryName)" >{{constList29[ind][0].categoryName}}>></div>
        <el-row type="flex" justify="space-between" v-if="constList29[ind][0].articleList!=null&&constList29[ind][0].articleList!=false">
          <el-col class="ff_left" :span="12" >
            <div v-if="constList29[ind][0].articleList[0]!=false" @click="detailClick(constList29[ind][0].articleList[0].articleId,constList29[ind][0].articleList[0].categoryId,constList29[ind][0].categoryName)">
            <div class="left_img">
              <MoudleImg :imgSrc="constList29[ind][0].articleList[0].coverImage!=false?constList29[ind][0].articleList[0].coverImage:null" :textCont="constList29[ind][0].categoryName"  :elementWidth="400" />
            </div>
            <div class="left_title">{{constList29[ind][0].articleList[0].title}}</div>
            <div class="left_cont ellipsis3">{{constList29[ind][0].articleList[0].description}}</div></div>
          </el-col>
          <el-col class="ff_right" :span="12">
            <ul class="right_ul">
              <div class="right_a" v-for="(item, index) in constList29[ind][0].articleList" :key="index"  @click="detailClick(item.articleId,item.categoryId,constList29[ind][0].categoryName)"><li  v-if="index>0" class="right_li ellipsis">{{constList29[ind][0].articleList[index].title}}</li></div>
            </ul>
          </el-col>
        </el-row>
       </div>
       <div class="cont_ff">
        <div class="ff_title" @click="listClick(2,constList29[ind][1].categoryId,constList29[ind][1].categoryName)" >{{constList29[ind][1].categoryName}}>></div>
        <el-row type="flex" justify="space-between" v-if="constList29[ind][1].articleList!=null&&constList29[ind][1].articleList!=false">
          <el-col class="ff_right" :span="12">
            <ul class="right_ul" style="padding-left:0px;padding-right:20px;">
              <div class="right_a" v-for="(item, index) in constList29[ind][1].articleList" :key="index"  @click="detailClick(item.articleId,item.categoryId,constList29[ind][1].categoryName)"><li  v-if="index>0" class="right_li ellipsis">{{item.title}}</li></div>
            </ul>
          </el-col>
          <el-col class="ff_left" :span="12" >
            <div  @click="detailClick(constList29[ind][1].articleList[0].articleId,constList29[ind][1].articleList[0].categoryId,constList29[ind][1].categoryName)">
            <!-- <el-image class="left_img" :src="constList29[0][0].articleList[0].coverImage" fit="cover"></el-image> -->
             <div class="left_img" v-if="constList29[ind][1].articleList[0]!=false">
                <MoudleImg :imgSrc="constList29[ind][1].articleList[0].coverImage!=false?constList29[ind][1].articleList[0].coverImage:null" :textCont="constList29[ind][1].categoryName" :elementWidth="400"  />
             </div>
            <div class="left_title">{{constList29[ind][1].articleList[0].title}}</div>
            <div class="left_cont ellipsis3">{{constList29[ind][1].articleList[0].description}}</div></div>
          </el-col>
        </el-row>
       </div>
       </div>
      <!-- 广告 -->
      <el-image class="middle_img"
                :src="imgadMiddle"
                fit="cover"
              ></el-image>
      
      <!-- 生态环保 -->
      <div class="cont_eco">
        <!-- 左侧 -->
        <div class="eco_left">
          <div class="left_cont" v-for="(item, index) in constList46" :key="index">
            <div class="eco_head">
              <p class="head_title">{{ item.categoryName }}</p>
              <p @click="listClick(2,item.categoryId,item.categoryName)" class="head_more curPointer">更多 ＞</p>
            </div>
            <div class="eco_list">
              <div
                v-if="
                  constList46.length > 1 &&
                  ((index == 0 && constList46[index].categoryId == 39) ||
                    (index == 1 && constList46[index].categoryId == 46) )
                "
              >
              <div v-if="constList46[index].articleList != false">
              <p
                v-for="(items, indexs) in constList46[index].articleList"
                :key="indexs"
                class="newsList ellipsis"
                @click="detailClick(constList46[index].articleList[indexs].articleId,constList46[index].categoryId,constList46[index].categoryName)"
              >
                {{ items.title }}
              </p></div>
              <div v-else><p class="home_empty">暂无数据</p></div>
            </div>
            </div>
          </div>
        </div>
        <!-- 右侧 -->
        <div class="eco_right" v-if="constList37!=false">
          <div class="eco_head">
            <p class="head_title">{{constList37.categoryName}}</p>
            <p @click="listClick(2,36,constList37.categoryName)" class="head_more curPointer">更多 ＞</p>
          </div>
          <div class="eco_list">
            <div class="list_detail curPointer" @click="detailClick(constList37Top.articleId,36,constList37.categoryName)">
              <!-- <el-image
                style="width: 380px; height: 300px"
                :src="constList37Top.coverImage!=false?constList37Top.coverImage:personBanner"
                fit="cover"
              ></el-image> -->
             <div style="width: 380px; height: 340px" v-if="constList37Top!=false">
              <MoudleImg :imgSrc="constList37Top.coverImage!=false?constList37Top.coverImage:null" :textCont="constList37.categoryName" :elementWidth="400"  />
             </div>
              <div class="detail_cont">
                <p class="cont_title ellipsis2">
                  {{constList37Top.title}}
                </p>
                <p class="cont_desic ellipsis10" v-html="constList37Top.description">
                </p>
              </div>
            </div>
            <div class="right_list">
              <p
                @click="detailClick(constList37.articleList[indexs].articleId,36,constList37.categoryName)"
                v-for="(items, indexs) in constList37.articleList"
                :key="indexs"
                class="newsList ellipsis"
              >
                <span>{{ items.title }}</span>
              </p>
            </div>
          </div>
        </div>
      </div>
      <!-- 广告 -->
      <el-image class="middle_img"
                :src="imgadBottom"
                fit="cover"
              ></el-image>
        <!-- 新关注民生 -->
       <div class="cont_attention">
        <div class="atten_wrap" v-for="(item,index) in constList42" :key="index">
          <div  class="atten_row" v-if="constList42[index][0]!=null">
            <p class="atten_title"  @click="listClick(2,constList42[index][0].categoryId,constList42[index][0].categoryName)">{{constList42[index][0].categoryName}}</p>
            <el-row type="flex" justify="space-between">
              <el-col :span="16" class="atten_left" v-if="constList42[index][0].articleList[0]!=false" @click="detailClick(constList42[index][0].articleList[0].articleId,constList42[index][0].articleList[0].categoryId,constList42[index][0].categoryName)">
                 <div class="left_img">
                    <MoudleImg :imgSrc="constList42[index][0].articleList[0].coverImage!=false?constList42[index][0].articleList[0].coverImage:null" :textCont="constList42[index][0].categoryName" />
                 </div>
                <div class="left_cont" v-if="constList42[index][0].articleList[0]!=null">
                  <p class="cont_title ellipsis">{{constList42[index][0].articleList[0].title}}</p>
                  <p class="cont_text ellipsis3">
                    {{constList42[index][0].articleList[0].description}}
                  </p>
                  <p class="cont_click">显示详情></p>
                </div>
              </el-col>
              <el-col :span="8" >
                <ul class="right_ul">
                  <div @click="detailClick(items.articleId,items.categoryId,constList42[index][0].categoryName)" class="right_a" v-for="(items, indexs) in constList42[index][0].articleList" :key="indexs"><li v-if="indexs>0" class="right_li ellipsis">{{items.title}}</li></div>
                </ul>
              </el-col>
            </el-row>
          </div>
          <div  class="atten_row" v-if="constList42[index][1]!=null">
            <p class="atten_title" @click="listClick(2,constList42[index][1].categoryId,constList42[index][1].categoryName)">{{constList42[index][1].categoryName}}</p>
            <el-row type="flex" justify="space-between">
              <el-col :span="8">
                <ul class="right_ul" style="padding-left:0;padding-right:20px;">
                  <div @click="detailClick(items.articleId,items.categoryId,constList42[index][1].categoryName)"  class="right_a" v-for="(items, indexs) in constList42[index][1].articleList" :key="indexs"><li v-if="indexs>0"  class="right_li ellipsis">{{items.title}}</li></div>
                </ul>
              </el-col>
              <el-col :span="16" v-if="constList42[index][1].articleList[0]!=false" class="atten_left" @click="detailClick(constList42[index][1].articleList[0].articleId,constList42[index][1].articleList[0].categoryId,constList42[index][1].categoryName)">
                   <div class="left_img">
                    <MoudleImg  :imgSrc="constList42[index][1].articleList[0].coverImage!=false?constList42[index][1].articleList[0].coverImage:null" :textCont="constList42[index][1].categoryName" />
                   </div>
                <div class="left_cont" v-if="constList42[index][1].articleList[0]!=null">
                  <p class="cont_title ellipsis">{{constList42[index][1].articleList[0].title}}</p>
                  <p class="cont_text ellipsis3">
                    {{constList42[index][1].articleList[0].description}}
                  </p>
                  <p class="cont_click">显示详情></p>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
       </div>
      <!-- 工作人员查询 -->
      <div class="cont_staff">
        <p class="staff_title">工作人员查询</p>
        <div class="staff_screen">
          <span class="screen_title"> 姓名</span>
          <el-input
            class="screen_ipt"
            v-model="lawyerData.staffName" onkeyup="this.value=this.value.replace(/\s*/g,'')"
            placeholder="请输入查询姓名"
          ></el-input>
        </div>
        <div class="staff_screen">
          <span class="screen_title">编号</span>
          <el-input
            class="screen_ipt"
            v-model="lawyerData.staffNum" onkeyup="this.value=this.value.replace(/\s*/g,'')"
            placeholder="请输入查询编号"
          ></el-input>
        </div>
        <el-button class="staff_btn" type="danger" round @click="screenClick()"
          >搜索</el-button
        >
      </div>
    </div>
  </div>
</template>
<script>
import { homeCont } from "@/api/home";
import MoudleImg from "@/components/moudleImg.vue";
export default {
  components: {
    MoudleImg
  },
  data() {
    return {
      // banner图
      imgBanner: require("@/assets/imgs/banner.png"),
      swiperBanner: require("@/assets/imgs/swiperBanner.jpg"),
      imgadTop:require('@/assets/imgs/ad_top.jpg'),
      imgadMiddle:require('@/assets/imgs/ad_middle.jpg'),
      imgadBottom:require('@/assets/imgs/ad_bottom.jpg'),
      artBanner:[
        require('@/assets/imgs/anti_01.jpg'),
        require('@/assets/imgs/anti_02.jpg'),
        require('@/assets/imgs/anti_03.jpg'),
        require('@/assets/imgs/anti_04.jpg'),
      ],
      personBanner:require('@/assets/imgs/personBanner.jpg'),
      report:[require('@/assets/imgs/report.jpg'),
      require('@/assets/imgs/report_02.jpg'),
      require('@/assets/imgs/report_03.jpg')],

      imgNews: [
        { path: "", url: "", title: "图片1" },
        { path: "", url: "", title: "图片2" },
      ],
      contFirst: "综合资讯",
      
      peopleName: "关注民生",
      


      constList24: [],//要闻
      constList33: [],//政策法规
      constList32: [],//反腐倡廉  //法制调查
      constList29: [],//专题报道 4个 2对

      constList46: [],//普法宣传
      constList39: [], 

      
      constList37Top: [],
      constList37: [],//生态环保

      constList42: [],
      tabOne:0,//tab当前选中索引 综合资讯
      tabTwo:0,//tab当前选中索引 关注民生

      lawyerData :{
        staffName:'',//名字
        staffNum:'',//编号
      }
    };
  },
  created() {
    this.homeContF();
  },
  computed:{
    
  },
  methods: {
    // tab切换方法
    handleClick(tab, event) {
        console.log(tab.index);
        this.tabOne = tab.index;
      },
    handleTwoClick(tab, event) {
        console.log(tab.index);
        this.tabTwo = tab.index;
      },
    // 广告点击跳转
    adClick(type){
      // if(type=='top'){
      //   window.open('https://www.fzzxjj.net','_blank');
      // }
    },
    // 获取数据
    homeContF() {
      let data = {
        pageNum:1,
        pageSize:11
      }
      homeCont(data).then((res) => {
        if (res.code == 0) {
          let result = res.data;
          console.log("res", res);
          let category29 = [];
          let category42 = [];
          result.forEach((item, index) => {
            // 24	要闻 33	政策法规  32	反腐倡廉  38	法制调查
            // 29	专题报道 31	法律援助  30	舆论监督  45	科技金融
            // 46	普法宣传  39	关注民生      36	生态环保
            // 42	文化旅游  47	食品健康  43	名人诗画
            if(item.categoryId == 24 ){
                this.constList24=item;
                console.log('this.constList24',this.constList24)
            }else if(item.categoryId == 33 ){
              if(item.articleList!=false){
                  item.articleList = item.articleList.splice(0,9)
                }
              this.constList33 = item;
            } else if (
              item.categoryId == 29 || item.categoryId == 30|| item.categoryId == 31|| item.categoryId == 45
            ) {
              // ||
              // item.categoryId == 30 ||
              // item.categoryId == 31
              if(item.articleList!=false){
                  item.articleList = item.articleList.splice(0,9)
                }
            if(category29.length<2){
              category29.push(item)
            }else{
              category29 = [];
              category29.push(item)
            }
            if(category29.length==2){
              this.constList29.push(category29);
            }
            console.log('this.constList29',this.constList29[0])
            }else if (
              item.categoryId == 30
            ) {
               if(item.articleList!=false){
                  item.articleList = item.articleList.splice(0,5)
                }
              this.constList30=item;
            }  else if (
              item.categoryId == 32 ||
              item.categoryId == 38 
            ) {
              if(item.articleList!=false){
                  item.articleList = item.articleList.splice(0,5)
                }
              this.constList32.push(item);
            } else if (item.categoryId ==39||item.categoryId ==46) {
              if(item.articleList!=false){
                item.articleList = item.articleList.slice(0,5)
              }
              this.constList46.push(item);
              console.log('this.constList39',this.constList39)
            }else if (item.categoryId == 36) {
              this.constList37Top = item.articleList[0];
              if(item.articleList!=false){
                item.articleList = item.articleList.slice(1,11)
              }
              this.constList37 = item;
            }else if (
              item.categoryId == 39||item.categoryId == 46
            ) {
               if(item.articleList!=false){
                  item.articleList = item.articleList.splice(0,5)
                }
              this.constList39.push(item);
            }else if (
              item.categoryId == 42 ||item.categoryId == 43 ||item.categoryId == 47
            ) {
              if(item.articleList!=false){
                  item.articleList = item.articleList.splice(0,6)
                }
               if(category42.length<2){
                  category42.push(item)
                }else{
                  category42 = [];
                  category42.push(item)
                  if(this.constList42.length>0){
                    this.constList42.push(category42);
                  }
                }
                if(category42.length==2){
                  this.constList42.push(category42);
                }
              console.log('category42f',this.constList42)
            }else if (item.categoryId=="indexFocus"){
              this.imgNews = item.articleList;
            }
          });
          
              console.log('this.constList39',this.constList39)
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 列表页跳转
    listClick(type,id,name) {
      let routeUrl = null;
      if(type==1){
        routeUrl = this.$router.resolve({ path: "/list", query: { id: this.constList24[this.tabOne].categoryId,name:this.constList24[this.tabOne].categoryName } });
      }else if(type==3){
        routeUrl = this.$router.resolve({ path: "/list", query: { id: this.constList39[this.tabTwo].categoryId,name:this.constList39[this.tabTwo].categoryName } });
      }else{
        routeUrl = this.$router.resolve({ path: "/list", query: { id: id,name:name } });
      }
      
     window.open(routeUrl.href,'_blank')
    },
    // 详情页跳转
    detailClick(id,listId,listName) {
     const routeUrl = this.$router.resolve({ path: "/detail", query: { id: id,listId:listId,listName:listName } });
     window.open(routeUrl.href,'_blank')
    },
    // 律师搜索
    screenClick() {
      let data = this.lawyerData;
      if(data.staffName==''||data.staffNum==''){
        this.$message({
            type: 'info',
            message: '请输入律师姓名和编号'
          });
        return
      }
      this.$router.push({ path: "/screen", query: data });
    },
  },
};
</script>
<style lang="scss" scoped>
// @import  'common/ellipsis_move';
// 公共样式
@mixin disCenter {
  display: flex;
  justify-content: space-between;
}
.head_more {
  font-size: 14px;
  color: rgb(136, 136, 136);
}
.tabs_more {
  position: absolute;font-size:14px;
  top: 13px;
  right: 0;
}
// 广告
.middle_img {
  width: 1200px;
}
.right_ul{
          margin-top:0;
          margin-bottom:0;list-style-position: inside; }
// 公共样式结束
.home_wrap {
  width: 100%;
  margin-top: 0;
  .home_cont {
    width: 1200px;
    margin: 10px auto 0;
    .home_empty {
      text-align: center;
      width: 100%;
      line-height: 100px;
    }
    // 图片模块
    .cont_img {
      @include disCenter;margin-bottom:20px;
      .report_cont {
        width: 320px;
        .cont_head {
          display: flex;
          justify-content: space-between;
          align-items: center;
          height: 58px;
          line-height: 58px;
          .head_p {
            position: relative;
            font-size: 22px;
            font-weight: 600;
          }
          .head_span {
            font-size: 14px;
            color: rgb(136, 136, 136);
          }
        }
        .cont_list {
          font-size:16px;
          .list_img {
            @include disCenter;
            .img {
              width: 190px;
              height: 136px;
              margin-right: 20px;
            }
            .img_right {
              line-height: 26px;width:168px;
              .right_title {
                font-size: 14px;
                color: #333;
                font-weight: 600;
                margin-top: -4px;
              }
              .right_desic {
                font-size: 12px;
                color: #666;
                line-height: 20px;
                margin-top: 10px;
              }
            }
          }
        }
      }
      .newsList {
        font-size:16px;
        &:first-child {
          margin-top: -10px;
        }
      }
      .new_list_cont {
        position: relative;
        width:500px;
      }
      .new_wrap {
        position: relative;
        width: 850px;
        height: 560px;
        overflow: hidden;
        .new_img {
          width: 100%;
          height: 100%;
          background: cyan;
        }
        .new_title {
          position: absolute;
          bottom: 0;
          left: 0;
          font-size: 14px;
          color: #fff;
          display: inline-block;
          background: rgba(0, 0, 0, 0.5);
          width: 860px;
          height: 60px;
          line-height: 60px;
          padding-left: 20px;
          margin-bottom: 0;
        }
      }
    }
    .cont_text {
      width: 650px;
      .el-tabs__header .el-tabs__nav-wrap .el-tabs__item {
        color: pink !important;
      }
    }

    .newsList {
      position: relative;
      padding-left: 14px;
      cursor: pointer;
      color: #333;
      line-height: 56px;
      display: block;
      font-size: 16px;
      width: 98%;
      .list_img{
        @include disCenter;
        color:#212121;
      .img{
        width:350px;height:346px;
      }
      .img_right{
        width:274px;line-height:30px;
        .right_title {
          font-size:18px;margin-bottom:10px;
        }
      }
      }
      &:hover {
        color: #bd1a2d;
        
        &:after{
          background:#bd1a2d;
        }
      }
      &:after {
        content: "";
        width: 4px;
        height: 4px;
        border-radius: 4px;
        background: #5c5c5c;
        position: absolute;
        left: 0;
        top: 26px;
      }
    }
    // 专题报道
    .cont_report {
      @include disCenter;
      // 带图片内容
        .left_imgCont{
          @include disCenter;
          cursor: pointer;
          .img_left{
            width:500px;height:336px;
          }
          .img{
            width:300px;height:260px;
          }
          .left_cont{
            margin-left:10px;width:300px;
            .cont_title{
              font-size:18px;font-weight:600;
            }
            .cont_des{
              font-size:16px;line-height:36px;margin-top:10px;
            }
          }
      }
       .new_list_cont {
        position: relative;
        width:650px;
      }
      .report_cont {
        width: 510px;
        .left_ul{
          padding-left:0;
        }
        .cont_head {
          display: flex;
          justify-content: space-between;
          align-items: center;
          height: 58px;
          line-height: 58px;
          .head_p {
            position: relative;
            font-size: 22px;
            font-weight: 600;
          }
          .head_span {
            font-size: 14px;
            color: rgb(136, 136, 136);
          }
        }
        .cont_list {
          font-size:16px;
          .list_img {
            @include disCenter;
            .img {
              width: 190px;
              height: 136px;
              margin-right: 20px;
            }
            .img_right {
              line-height: 26px;width:300px;
              .right_title {
                font-size: 18px;
                color: #333;
                font-weight: 600;
                margin-top: -4px;
              }
              .right_desic {
                font-size: 16px;
                color: #666;
                line-height: 28px;
                margin-top: 10px;
              }
            }
          }
        }
      }
    }
    // 新反腐倡廉
    .cont_wrap{
    .cont_ff{color:#212121;
      .ff_title{cursor: pointer;
        font-size:22px;margin-bottom:30px;margin-top:20px;font-weight:600;
      }
      .ff_left{
        cursor: pointer;
        .left_img{
          width:100%;height:210px;background:pink;margin-bottom:10px;
        }
        .left_title{
          font-size:18px;margin-bottom:10px;color:#212121;
        }
        .left_cont{
          font-size:16px;color:#666;line-height:28px;       }
      }
      .ff_right{
        cursor: pointer;
        .right_ul{
          .right_a{
            color:#212121;line-height:44px;font-size:16px;
            :hover{
              color:#bd1a2d;
            }
          }
        }
        
      }
    }
    }
    // 新关注民生
    .cont_attention{
      .atten_wrap{
        margin-top:10px;
        .atten_row{
          
          .atten_title{
            cursor:pointer;
            font-size:20px;margin-bottom:20px;margin-top:20px;font-weight:600;
          }
        }
        .atten_left{
            cursor:pointer;
          @include disCenter;
          background:#ececec;
          padding:20px;
          .left_img{
            width:260px;height:180px;
          }
          .left_cont{
            width:480px;
            .cont_title{
              font-size:18px;color:#212121;
            }
            .cont_text{
              font-size:14px;color:#333;line-height:32px;
            width:490px;margin-top:20px;height:100px;
            }

            .cont_click{
              font-size:12px;color:#666;text-align:right;margin-top:16px;
            }
          }
        }
        .right_ul{
            cursor:pointer;
          .right_a{
                color: #212121;
    line-height: 44px;font-size:16px;
          }
          .right_text{

          }
        }
      }
    }
    // 反腐倡廉
    .cont_corrup {
      .corrup_item {
        margin-bottom: 20px;
        padding: 0 8px;
        .corr_head {
          text-align: center;
          position: relative;
          font-size: 18px;
          font-weight: 600;
          padding: 10px 0;
          &:after {
            position: absolute;
            content: "";
            width: 110px;
            height: 4px;
            background: #bd1a2d;
            top: 0;
            left: 0;
            right: 0;
            margin: 0 auto;
          }
        }
        .corr_list {
          min-height:230px;
          .list_a {
            padding-left: 14px;
            cursor: pointer;
            font-size: 14px;
            line-height: 46px;
            &:hover {
              color: #bd1a2d;
            }
          }
        }
      }
    }
    // 生态环保
    .cont_eco {
      @include disCenter;

      .eco_head {
        @include disCenter;
        // border-bottom: 2px solid #bd1a2d;
        align-items: center;
        margin-bottom: 10px;
        .head_title {
          position: relative;
          height: 48px;
          z-index: 3;
          line-height: 48px;
          font-size: 22px;
          font-weight: 600;
          // &:after {
          //   content: "";
          //   width: 120px;
          //   height: 48px;
          //   background: #bd1a2d;
          //   position: absolute;
          //   top: 0;
          //   left: 0;
          //   z-index: -1;
          // }
        }
      }
      .eco_left {
        width: 400px;
        .left_cont {
        }
      }
      .eco_right {
        width: 770px;
        .eco_head {
          margin-bottom: 0;
        }
        .list_detail {
          @include disCenter;
          height: 340px;
          .detail_cont {
            width: 370px;
            .cont_title {
              font-size: 18px;
              font-weight: 600;
              color: #333;
              line-height: 30px;
              margin-top: 8px;
            }
            .cont_desic {
              // @include ellipsis_move(5);
              font-size: 16px;
              color: #666;
              line-height: 26px;
              margin-top: 6px;
              -webkit-line-clamp: 9;
              text-indent:20px;
            }
          }
        }
        .right_list {
          @include disCenter;
          flex-wrap: wrap;
          margin-top: 10px;
          .newsList {
            width: 47%;

          }
        }
      }
    }
    // 关注民生
    .cont_people {
      position: relative;
      .list_wrap {
        @include disCenter;
        flex-wrap: wrap;
        .newsList {
          width: 48%;
          display: inline-block;
          &:nth-child(odd){
            margin-right:16px;
          }
        }
      }
    }
    // 工作人员查询
    .cont_staff {
      background: #f3f3f3;
      padding: 10px 20px;
      display: flex;
      align-items: center;
      color: #333;
      margin: 20px 0;
      .staff_title {
        font-size: 16px;
        font-weight: 600;
        margin-right: 20px;
      }
      .staff_screen {
        @include disCenter;
        align-items: center;
        .screen_title {
          font-size: 14px;
        }
        .screen_ipt {
          width: 300px;
          margin: 0 50px 0 16px;
        }
      }
      .staff_btn {
        font-size: 14px;
        background: #bd1a2d;
        border-color: #bd1a2d;
        padding: 4px 30px;
      }
    }
  }
}
</style>